import React from 'react';
import { useSelector } from 'react-redux';
import { isPdfArea } from '../../../CommonSelectors/CommonAreaSelector';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Separator } from '../../../CommonComponents/OPL/Separator/Separator';

interface Props {
  title?: string;
}

export const PDFTitle = ({ title }: Props) => {
  const isPrint = useSelector(isPdfArea);

  if (!isPrint || !title) {
    return null;
  }

  return (
    <>
      <Text as="h1" fontSize="h4" fontWeight={500} color="neutral.600">
        {title}
      </Text>

      <Separator mb="16" />
    </>
  );
};
